import type { FleetBatteryStatusDto } from "@/lib/api";
import type { BatteryStatus } from "@/types/telematics.types";

export function mapBatteryStatusDtoToBatteryStatus(
	dto: FleetBatteryStatusDto
): BatteryStatus {
	return {
		batteryPercentage: dto.batteryPercentage,
		cruisingRangeKm: dto.cruisingRangeKm,
		chargingStatus: dto.chargingStatus,
	};
}
